"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEntityTypesOptions = exports.EntityTypesOptionsContextProvider = exports.useEntityTypesOptionsContextValue = exports.EntityTypesOptionsContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const urls_1 = require("./urls");
exports.EntityTypesOptionsContext = (0, react_1.createContext)(null);
const useEntityTypesOptionsContextValue = (entityTypes) => {
    return (0, react_1.useMemo)(() => {
        const linkEntityTypesRecord = {};
        const nonLinkEntityTypesRecord = {};
        for (const entityType of Object.values(entityTypes)) {
            const target = entityType.allOf?.length === 1 &&
                entityType.allOf[0]?.$ref === urls_1.linkEntityTypeUrl
                ? linkEntityTypesRecord
                : nonLinkEntityTypesRecord;
            target[entityType.$id] = entityType;
        }
        return {
            entityTypes: nonLinkEntityTypesRecord,
            linkTypes: linkEntityTypesRecord,
        };
    }, [entityTypes]);
};
exports.useEntityTypesOptionsContextValue = useEntityTypesOptionsContextValue;
const EntityTypesOptionsContextProvider = ({ children, entityTypeOptions, }) => {
    const value = (0, exports.useEntityTypesOptionsContextValue)(entityTypeOptions);
    return ((0, jsx_runtime_1.jsx)(exports.EntityTypesOptionsContext.Provider, { value: value, children: children }));
};
exports.EntityTypesOptionsContextProvider = EntityTypesOptionsContextProvider;
const useEntityTypesOptions = () => {
    const entityTypesOptionsContext = (0, react_1.useContext)(exports.EntityTypesOptionsContext);
    if (!entityTypesOptionsContext) {
        throw new Error("no EntityTypesOptionsContext value has been provided");
    }
    return entityTypesOptionsContext;
};
exports.useEntityTypesOptions = useEntityTypesOptions;
